import { __awaiter } from '../_virtual/_tslib.js';
import { logger } from '@dynamic-labs/wallet-connector-core';
import { BloctoEvm } from './BloctoEvm.js';

class BloctoEmailConnector extends BloctoEvm {
    constructor() {
        super(...arguments);
        this.canConnectViaEmail = true;
    }
    get email() {
        return this._email;
    }
    setEmail(email) {
        this._email = email;
        if (!email) {
            localStorage.removeItem(BloctoEmailConnector.storageEmailKey);
        }
        else {
            localStorage.setItem(BloctoEmailConnector.storageEmailKey, email);
        }
    }
    fetchPublicAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const client = this.getClient();
                if (!(client === null || client === void 0 ? void 0 : client.ethereum)) {
                    return undefined;
                }
                const addresses = yield client.ethereum.request({
                    method: 'eth_requestAccounts',
                    // When the email is provided, the login modal will prefill the email field.
                    params: this.email ? [this.email] : undefined,
                });
                if ((addresses === null || addresses === void 0 ? void 0 : addresses.length) > 0) {
                    return addresses[0];
                }
                return undefined;
            }
            catch (e) {
                logger.error(e);
                return Promise.reject(e);
            }
        });
    }
    getConnectedAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const client = this.getClient();
            if (!client) {
                return [];
            }
            if (client.ethereum) {
                const accounts = yield client.ethereum.request({
                    method: 'eth_requestAccounts',
                    // When the email is provided, the login modal will prefill the email field.
                    params: this.email ? [this.email] : undefined,
                });
                return accounts || [];
            }
            return [];
        });
    }
    clearEmail() {
        this.setEmail(undefined);
    }
    endSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const client = this.getClient();
            localStorage.removeItem('sdk.session');
            if (this.email && // cancel the session only if the email is set
                client &&
                client.ethereum &&
                this.checkForSessionAccounts()) {
                yield client.ethereum.request({ method: 'wallet_disconnect' });
                this.removeClient();
            }
            this.clearEmail();
        });
    }
}
BloctoEmailConnector.storageEmailKey = 'blocto-email';

export { BloctoEmailConnector };
